import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SurveyViaLinkServiceService } from '../../core/services/SurveyViaLink.service';
import { SurveyView } from './surveyView.enum';
import { AlertMessages, AlertType } from '../../core/AlertMessages';
import { SurveySaveModel } from './SurveySave.model';

@Component({
  selector: 'app-survey-via-link',
  templateUrl: './survey-via-link.component.html',
  styleUrls: ['./survey-via-link.component.css']
})

export class SurveyViaLinkComponent implements OnInit {
  temporaryListSingle: any[] = [];
  temporaryListMultiple: any[] = [];
  showExpirySurvey: boolean = false;
  showOverlayIpsLinkSurvey: boolean = false;
  questionType;
  finalList: any[] = [];
  surveyData: any;
  linkCode: string;
  questions: any[] = [];
  patientData: any;
  alertText: string;
  showAlert: boolean;
  alertAction: string;
  surveyViewSelectedUwp;
  surveyViewSelectedWeb;
  attemptedQuestion: number = 0;
  constructor(private _route: ActivatedRoute, private router: Router, private _service: SurveyViaLinkServiceService) { }

  ngOnInit() {
    this.surveyViewSelectedUwp = SurveyView.uwp;
    this.surveyViewSelectedWeb = SurveyView.web;
    this._route.queryParams.subscribe(params => { this.linkCode = params['LinkCode'] });
    this.getSurveyQuestion(this.linkCode);
  }

  onInitInitializeData(listData) {
    this.temporaryListSingle = [];
    this.temporaryListMultiple = [];
    this.finalList = [];
    if (listData !== undefined && listData !== null) {
      if (listData.length > 0) {
        listData.forEach(element => {
          if (element.qtype == 1 || element.qtype == 3) {
            this.temporaryListSingle.push(element);
          } else if (element.qtype == 2) {
            this.temporaryListMultiple.push(element);
          }
        });
      }
    }

    var tempSingleLength: number = this.temporaryListSingle.length == null ? 0 : this.temporaryListSingle.length == undefined ? 0 : this.temporaryListSingle.length;
    var tempMultipleLength: number = this.temporaryListMultiple.length == null ? 0 : this.temporaryListMultiple.length == undefined ? 0 : this.temporaryListMultiple.length;
    this.attemptedQuestion = tempMultipleLength + tempSingleLength;
  }


  getSurveyQuestion(code) {
    this.showOverlayIpsLinkSurvey = true;
    this._service.accessSurveyLink(this.linkCode).subscribe((data: any) => {
      this.surveyData = data;
      this.patientData = this.surveyData.PatientData;
      if (this.surveyData.StatusId == 0) {
        this.showExpirySurvey = true;
        this.showOverlayIpsLinkSurvey = false;
      }
      else {
        this.showExpirySurvey = false;
        this.showOverlayIpsLinkSurvey = false;
        this.questions = this.surveyData.surveyModel.questionList;
        this.onInitInitializeData(this.surveyData.surveyModel.oldAnswers);
      }
    });
  }

  store(event, newValue, nameValue, questionType, questId, qTypeId, question, codeType, caseCodeId, caseCodeName, caseGroupName, qtypeName, isEnabled, optionsCount) {
    this.questionType = questionType;
    if (this.questionType == 1 || this.questionType == 3) {
      if (this.temporaryListSingle.length > 0) {
        let list = this.temporaryListSingle.filter(i => i.id == questId);
        if (list.length > 0) {
          let index = this.temporaryListSingle.findIndex(i => i.id == questId);
          this.temporaryListSingle.splice(index, 1);
          this.temporaryListSingle.push({
            "id": questId,
            "question": question,
            "qTypeId": qTypeId,
            "codeType": codeType,
            "caseCodeId": caseCodeId,
            "caseCodeName": caseCodeName,
            "caseGroupName": caseGroupName,
            "qtypeName": qtypeName,
            "isEnabled": isEnabled,
            "optionsCount": optionsCount,
            "qtype": questionType,
            "questOptions": [{
              "id": newValue,
              "option": nameValue,
              "weight": 0,
              "questionId": questId,
              "isSelected": true
            }]
          }
          );
        }
        else {
          this.temporaryListSingle.push({
            "id": questId,
            "question": question,
            "qTypeId": qTypeId,
            "codeType": codeType,
            "caseCodeId": caseCodeId,
            "caseCodeName": caseCodeName,
            "caseGroupName": caseGroupName,
            "qtypeName": qtypeName,
            "isEnabled": isEnabled,
            "optionsCount": optionsCount,
            "qtype": questionType,
            "questOptions": [{
              "id": newValue,
              "option": nameValue,
              "weight": 0,
              "questionId": questId,
              "isSelected": true
            }]
          }
          );
        }
      }
      else {
        this.temporaryListSingle.push({
          "id": questId,
          "question": question,
          "qTypeId": qTypeId,
          "codeType": codeType,
          "caseCodeId": caseCodeId,
          "caseCodeName": caseCodeName,
          "caseGroupName": caseGroupName,
          "qtypeName": qtypeName,
          "isEnabled": isEnabled,
          "optionsCount": optionsCount,
          "qtype": questionType,
          "questOptions": [{
            "id": newValue,
            "option": nameValue,
            "weight": 0,
            "questionId": questId,
            "isSelected": true
          }]
        }
        );
      }
    }
    else if (this.questionType == 2) {
      if (event.target.checked == true) {
        if (this.temporaryListMultiple.length > 0) {
          var filterTemporayMultipleQuestion = this.temporaryListMultiple.filter(ij => ij.id == questId)[0];
          if (filterTemporayMultipleQuestion !== undefined) {
            var indexOfQuestion = this.temporaryListMultiple.indexOf(filterTemporayMultipleQuestion);
            this.temporaryListMultiple[indexOfQuestion].questOptions.push({
              "id": newValue,
              "option": nameValue,
              "weight": 0,
              "questionId": questId,
              "isSelected": true
            })
          }
          else {
            this.temporaryListMultiple.push({
              "id": questId,
              "question": question,
              "qTypeId": qTypeId,
              "codeType": codeType,
              "caseCodeId": caseCodeId,
              "caseCodeName": caseCodeName,
              "caseGroupName": caseGroupName,
              "qtypeName": qtypeName,
              "isEnabled": isEnabled,
              "optionsCount": optionsCount,
              "qtype": questionType,
              "questOptions": [{
                "id": newValue,
                "option": nameValue,
                "weight": 0,
                "questionId": questId,
                "isSelected": true
              }]
            }
            );
          }
        }

        else {
          this.temporaryListMultiple.push({
            "id": questId,
            "question": question,
            "qTypeId": qTypeId,
            "codeType": codeType,
            "caseCodeId": caseCodeId,
            "caseCodeName": caseCodeName,
            "caseGroupName": caseGroupName,
            "qtypeName": qtypeName,
            "isEnabled": isEnabled,
            "optionsCount": optionsCount,
            "qtype": questionType,
            "questOptions": [{
              "id": newValue,
              "option": nameValue,
              "weight": 0,
              "questionId": questId,
              "isSelected": true
            }]
          }
          );
        }
      }
      else {
        let list = this.temporaryListMultiple.filter(i => i.id == questId);
        if (list.length > 0) {
          let indexOfMultipleQuestion = this.temporaryListMultiple.findIndex(ij => ij.id == questId);
          if (indexOfMultipleQuestion !== undefined) {
            if (this.temporaryListMultiple[indexOfMultipleQuestion].questOptions !== undefined) {
              var indexOfAnswerQuestion = this.temporaryListMultiple[indexOfMultipleQuestion].questOptions.filter(ijk => ijk.id == newValue)[0];
              if (indexOfAnswerQuestion !== undefined) {
                var indexOfOption = this.temporaryListMultiple[indexOfMultipleQuestion].questOptions.indexOf(indexOfAnswerQuestion);
                this.temporaryListMultiple[indexOfMultipleQuestion].questOptions.splice(indexOfOption, 1);
                if (this.temporaryListMultiple[indexOfMultipleQuestion].questOptions.length < 1) {
                  this.temporaryListMultiple.splice(indexOfMultipleQuestion, 1);
                }
              }
            }
          }
        }
      }
    }
    var tempSingleLength: number = this.temporaryListSingle.length == null ? 0 : this.temporaryListSingle.length == undefined ? 0 : this.temporaryListSingle.length;
    var tempMultipleLength: number = this.temporaryListMultiple.length == null ? 0 : this.temporaryListMultiple.length == undefined ? 0 : this.temporaryListMultiple.length;
    this.attemptedQuestion = tempMultipleLength + tempSingleLength;
  }

  saveSurvey(index) {
    this.finalList = [];
    if (this.temporaryListSingle !== undefined && this.temporaryListSingle !== null && this.temporaryListMultiple !== undefined && this.temporaryListMultiple !== null) {
      if (this.temporaryListSingle.length > 0 || this.temporaryListMultiple.length > 0) {
        this.showOverlayIpsLinkSurvey = true;
        this.temporaryListSingle.forEach(element => {
          this.finalList.push(element);
        });
        this.temporaryListMultiple.forEach(element => {
          this.finalList.push(element);
        });
        if (index == 1) {
          let SaveModel:SurveySaveModel = new SurveySaveModel(this.finalList,this.patientData.surveyPaperId,this.patientData.surveyShareId,this.patientData.eaPatientInfoId,this.patientData.saId);
          this._service.saveSurvey(SaveModel).subscribe((data) => {
            if (data == true) {
              this.showOverlayIpsLinkSurvey = false;
              AlertMessages.Show('Saved', 'Survey Is Saved!!!', AlertType.Success);
              this.getSurveyQuestion(this.linkCode);
            }
            else {
              this.showOverlayIpsLinkSurvey = false;
              AlertMessages.Show('Error', 'Error While Saving Survey!!!', AlertType.Error);
            }
          });
        }
        else if (index == 2) {
          let SubmitModel:SurveySaveModel = new SurveySaveModel(this.finalList,this.patientData.surveyPaperId,this.patientData.surveyShareId,this.patientData.eaPatientInfoId,this.patientData.saId);

          this._service.submitSurvey(SubmitModel).subscribe((data) => {
            if (data == true) {
              this.showOverlayIpsLinkSurvey = false;
              AlertMessages.Show('Submitted', 'Survey Is Submitted Successfully!!!', AlertType.Success);
              this.getSurveyQuestion(this.linkCode);
            }
            else {
              this.showOverlayIpsLinkSurvey = false;
              AlertMessages.Show('Error', 'Survey Submission Failed!!!', AlertType.Error);
            }
          });
        }
      }
      else {
        AlertMessages.Show('Warning', 'No question answered .. Attempt Atleast One Question!!!', AlertType.Warning);
      }
    } else {
      AlertMessages.Show('Warning', 'No question answered .. Attempt Atleast One Question!!!', AlertType.Warning);
    }
  }

  alertMessage(alertAction: string, message: string) {
    this.showAlert = true;
    this.alertAction = alertAction;
    this.alertText = message;
    this.alertClose();
  }

  alertClose() {
    setTimeout(() => {
      this.showAlert = false;
    }, 3000);
  }

}
